// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module__card___30lCi","heading":"Card-module__heading___3xWMY","image":"Card-module__image___3j2Xe","weeklyConversion":"Card-module__weeklyConversion___1Wiw9"};